import {SidebarCollapseIcon, SidebarExpandIcon} from '@primer/octicons-react'
import {Button, Tooltip} from '@primer/react'
import {FeatureFlags} from '@primer/react/experimental'
import {useCollapsibleSidebarContext} from '../CollapsibleSidebar/CollapsibleSidebar'
import type {Ref} from 'react'
import styles from './CollapseButton.module.css'

export interface CollapseButtonProps {
  /** Ref to the underlying button. */
  ref?: Ref<HTMLButtonElement>
}

export function CollapseButton({ref}: CollapseButtonProps) {
  const {isExpanded, visualIsExpanded, isExpansionSettled, isInDialog, sidebarId, onToggle} =
    useCollapsibleSidebarContext()
  const label = isExpanded ? 'Collapse sidebar' : 'Expand sidebar'
  const IconComponent = visualIsExpanded ? SidebarExpandIcon : SidebarCollapseIcon
  if (isInDialog) return null
  return (
    <FeatureFlags flags={{primer_react_merged_forwarded_refs: true}}>
      <Tooltip
        text={visualIsExpanded ? '' : label}
        direction="e"
        delay="medium"
        _privateDisableTooltip={visualIsExpanded}
        popover={visualIsExpanded ? undefined : 'auto'}
      >
        <Button
          data-component="Sidebar.CollapseButton"
          ref={ref}
          className={styles.CollapseButton}
          data-collapsed={!visualIsExpanded || undefined}
          leadingVisual={IconComponent}
          alignContent="start"
          labelWrap={isExpansionSettled}
          variant="invisible"
          onClick={onToggle}
          aria-expanded={isExpanded}
          aria-controls={sidebarId}
          aria-label={label}
        >
          {visualIsExpanded ? <span data-sidebar-collapse-content>Collapse sidebar</span> : null}
        </Button>
      </Tooltip>
    </FeatureFlags>
  )
}
